import React, { useEffect, useState } from 'react';
import {Navigate} from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { api } from 'common';
import ResponsiveDrawer from '../components/ResponsiveDrawer';
import CircularLoading from "../components/CircularLoading";

const DASHBOARD_ROLES = ['admin', 'fleetadmin'];

function matchUser(permit, usertype){
    let permitions = permit? permit.split(',') : [];
    let permitted = false;
    for(let i=0;i<permitions.length;i++){
        permitted = usertype === permitions[i]?true:false
        if(permitted) break;
    }
    return permitted;
}

function ProtectedRoute({ permit,children }) {
    const auth = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const { signOff } = api;
    const [checkedAuth,setCheckedAuth] = useState(false);

    useEffect(()=>{
        if(auth.profile && auth.profile.uid){
            // Attendre que usertype soit bien chargé avant de vérifier
            if (auth.profile.usertype) {
                // Si le rôle n'est pas autorisé sur cette plateforme web, on déconnecte
                if (!DASHBOARD_ROLES.includes(auth.profile.usertype)) {
                    dispatch(signOff());
                    return;
                }
                setCheckedAuth(true);
            }
            // Si usertype pas encore chargé, on attend (ne pas setCheckedAuth)
        }
        if(auth.error && auth.error.msg && !auth.profile){
            setCheckedAuth(true);
        }
    },[auth.profile, auth.error, dispatch, signOff])

    return(
        checkedAuth?
            auth.profile && auth.profile.uid?
                matchUser(permit,auth.profile.usertype) ? <ResponsiveDrawer>{children}</ResponsiveDrawer>:<Navigate to="/" />
            :<Navigate to="/" /> 
        :<CircularLoading/>
    )
}

export default ProtectedRoute;